export default "__VITE_ASSET__6c5ea17f__"